import React, { useEffect, useRef } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { getInitialize } from '../actions/action_auth';
import Loadingpage from '../pages/loadingpage';
import { useLocation, useNavigate } from 'react-router-dom';
// import { useLocation, useNavigate } from 'react-router';

export default function JwtProvider({ children }) {
  const dispatch = useDispatch();
  const location = useLocation();
  const navigate = useNavigate();
  const isSocialRoute = location.pathname.includes('social');
  const { loading, errors } = useSelector(state => state.user);
  const analyticsLoaded = useRef(false);

  useEffect(() => {
    // console.log("jwt provider")
    if (!isSocialRoute) {
      dispatch(getInitialize());
    }
  }, [isSocialRoute]);

  function loadAnalytics() {
  try {
    const gtm = document.createElement("script");
    gtm.src = "https://www.googletagmanager.com/gtm.js?id=GTM-WT4RPQW4";
    gtm.async = true;
    gtm.onerror = () => console.warn('GTM script failed to load');
    document.head.appendChild(gtm);
  } catch (e) { console.warn('GTM load error:', e); }

  try {
    window.dataLayer = window.dataLayer || [];
    window.gtag = function () { dataLayer.push(arguments); };
    window.gtag("js", new Date());
    window.gtag("config", "G-J5MV81T9KM");
  } catch (e) { console.warn('GA init error:', e); }

  try {
    (function(h,o,t,j,a,r){
      h.hj=h.hj||function(){(h.hj.q=h.hj.q||[]).push(arguments)};
      h._hjSettings={hjid:5018528, hjsv:6};
      a=o.getElementsByTagName('head')[0];
      r=o.createElement('script');r.async=1;
      r.src=t+h._hjSettings.hjid+j+h._hjSettings.hjsv;
      r.onerror = () => console.warn('Hotjar script failed to load');
      a.appendChild(r);
    })(window,document,'https://static.hotjar.com/c/hotjar-','.js?sv=');
  } catch (e) { console.warn('Hotjar load error:', e); }
}


  useEffect(() => {
    if (!loading && localStorage.getItem("accessToken") && !analyticsLoaded.current) {
      analyticsLoaded.current = true;
      loadAnalytics();
    }
  }, [loading]);

  useEffect(() => {
    if (!analyticsLoaded.current) return;
    window.dataLayer?.push({
      event: 'gtm.historyChange',
      'gtm.historyChangeSource': 'react-router',
      page: {
        path: location.pathname,
        search: location.search,
        title: document.title
      }
    });
    window.gtag?.('config', 'G-J5MV81T9KM', {
      page_path: location.pathname + location.search,
      page_title: document.title
    });
  }, [location.pathname, location.search]);

  useEffect(() => {
    dispatch({ type: "SET_DEFAULT_CURRENCY" });
  }, [dispatch]);
  // if(loading && !isSocialRoute) return <Loadingpage />
  if (loading && !isSocialRoute) return <div className="loader"></div>;
  // if(errors) return navigate('/signin')
  return <>{children}</>;
}
